<template>
  <main>
    <nav class="blog-breadcrumb" aria-label="Fil d'Ariane">
      <NuxtLink to="/">Accueil</NuxtLink>
      <span> &rsaquo; </span>
      <NuxtLink to="/blog">Blog</NuxtLink>
      <span> &rsaquo; </span>
      <span>{{ data?.title || 'Article' }}</span>
    </nav>
    <article>
      <ContentRenderer :value="data">
        <ContentRendererMarkdown :value="data" />
      </ContentRenderer>
    </article>
  </main>
</template>

<script setup>
  const route = useRoute()
  const slugPath = `/${route.params.slug.join('/')}`
  const { data } = await useAsyncData(`page-${slugPath}`, () =>
    queryCollection('content')
      .where('path', '=', slugPath)
      .first()
  )
  const { setSeoMeta } = useSeo()

  if (data.value) {
    setSeoMeta({
      title: data.value.title || 'Article de blog',
      description: data.value.description || 'Découvrez cet article sur la gestion administrative des freelances en régie.',
      type: 'article',
      keywords: data.value.tags || ['freelance', 'CRA', 'facturation'],
      url: `https://cra-freelance.fr/blog/${route.params.slug.join('/')}`,
      datePublished: data.value.datePublished,
      dateModified: data.value.dateModified,
      breadcrumbs: [
        { name: 'Accueil', url: 'https://cra-freelance.fr' },
        { name: 'Blog', url: 'https://cra-freelance.fr/blog' },
        { name: data.value.title, url: `https://cra-freelance.fr/blog/${route.params.slug.join('/')}` }
      ]
    })
  } else {
    setSeoMeta({
      title: 'Article non trouvé',
      description: 'L\'article demandé n\'a pas été trouvé.',
      noIndex: true
    })
  }

  definePageMeta({
    layout: 'site'
  })
</script>

<style lang="scss">
  .blog-breadcrumb {
    max-width: 900px;
    margin: 20px auto 0;
    padding: 0 20px;
    font-size: 14px;
    color: #888;

    a {
      color: #01498B;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 2px;
    }
  }
</style>
